import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import { createPinia } from 'pinia';
import axios from 'axios';

// ⭐ IMPORTA TU STORE MANUAL
import { createCartStore } from './stores/cart';

loadFonts();

const app = createApp(App);

// ⭐ CREA LA INSTANCIA DEL CARRITO
const cartStore = createCartStore();

// ⭐ PROVÉELA GLOBALMENTE
app.provide('cartStore', cartStore);

app.use(router);
app.use(vuetify);

const pinia = createPinia();
app.use(pinia);

app.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB-I6et1AftzkN3O-k4Czgh90TF1I_GH20',
    libraries: 'places',
  },
});

// ---- axios ----
const token = localStorage.getItem('token');
axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : '';

const baseURL = window.location.protocol === 'capacitor:' 
  ? 'https://mvexpress.mx'
  : 'https://mvexpress.mx/api';

axios.defaults.baseURL = baseURL;

app.mount('#app');
